import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { THEME_COLORS } from "../../../../../color";

const BarGraph = ({
  data = [],
  width = "100%",
  height = 300,
  options = {},
  //colors = ["#0475A3", "#0288A4", "#17A3AC", "#46C1BB"],
  colors = [
    THEME_COLORS.green,
    THEME_COLORS.yellow,
    THEME_COLORS.darkblue,
    THEME_COLORS.pink,
  ],

  icon = null,
  title = "",
}) => {
  console.log(data, "data in bar graph");
  const categories = useMemo(() => data.map((item) => item.name), [data]);
  const values = useMemo(() => data.map((item) => item.value), [data]);

  console.log(categories, "categories");
  const fOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
        columnWidth: "45%",
        dataLabels: {
          position: "top",
          hideOverflowingLabels: false,
        },
      },
    },
    grid: {
      padding: {
        top: 25,
      },
    },
    legend: {
      show: true,
      fontSize: "10px",
      fontWeight: 700,
      position: "right",
      markers: {
        size: 12,
        shape: "square",
        strokeWidth: 1,
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      formatter: (val) => `${val}%`,
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#304758"],
      },
    },
    xaxis: {
      categories,
      labels: {
        hideOverlappingLabels: false,
        trim: false,
        style: {
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: true,
        color: "#000",
        height: 2,
      },
      axisTicks: {
        show: true,
        color: "#000",
      },
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: true,
        color: "#000",
        width: 2,
      },
      axisTicks: {
        show: true,
        color: "#000",
      },
      ...(options.yaxis || {}),
      max:
        options.yaxis?.max !== undefined
          ? options.yaxis.max
          : (() => {
              const m = Math.max(...values, 0);
              const rawMax = m * 1.2;
            })(),
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 260,
          },
          plotOptions: {
            bar: {
              columnWidth: "65%",
            },
          },
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "9px",
            itemMargin: { horizontal: 4, vertical: 4 },
          },
          dataLabels: {
            style: { fontSize: "9px" },
            offsetY: -16,
          },
          xaxis: {
            labels: {
              rotate: -45,
              rotateAlways: true,
              style: { fontSize: "9px" },
              trim: false,
              minHeight: 55,
            },
          },
          yaxis: {
            labels: { style: { fontSize: "9px" } },
          },
          grid: {
            padding: { bottom: 40 },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 300,
          },
          plotOptions: {
            bar: {
              columnWidth: "55%",
            },
          },
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "10px",
          },
          dataLabels: {
            style: { fontSize: "10px" },
            offsetY: -18,
          },
          xaxis: {
            labels: {
              rotate: -35,
              rotateAlways: true,
              style: { fontSize: "10px" },
              trim: false,
              minHeight: 50,
            },
          },
          yaxis: {
            labels: {
              style: { fontSize: "10px" },
            },
          },
          grid: {
            padding: { bottom: 35 },
          },
        },
      },
    ],
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    ...options,
    yaxis: {
      min: 0,
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: true,
        color: "#000",
        width: 2,
      },
      axisTicks: {
        show: true,
        color: "#000",
      },
      ...(options.yaxis || {}),
      max:
        options.yaxis?.max !== undefined
          ? options.yaxis.max
          : (() => {
              const m = Math.max(...values, 0);
              if (m === 0) return 100;
              const rawMax = m * 1.2;
              const magnitude = Math.pow(10, Math.floor(Math.log10(rawMax)));
              let interval;
              if (rawMax / magnitude <= 2) {
                interval = magnitude * 0.2;
              } else if (rawMax / magnitude <= 5) {
                interval = magnitude * 0.5;
              } else {
                interval = magnitude;
              }
              return Math.ceil(rawMax / interval) * interval;
            })(),
    },
    xaxis: {
      ...(options.xaxis || {}),
      categories,
      labels: {
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
        trim: false,
        minHeight: 50,
        style: {
          fontSize: "12px",
        },
        ...(options.xaxis?.labels || {}),
      },
    },
  };

  const series = [
    {
      name: "Value",
      data: values,
    },
  ];

  return (
    <div className="w-full">
      <div className="flex gap-x-4 items-center ">
        {icon && <div className=" p-1 ">{icon}</div>}
        <h2
          className="m-0 p-0 font-calibri font-bold text-[20px] leading-6"
          style={{ color: THEME_COLORS.green }}
        >
          {title}
        </h2>
      </div>
      <Chart
        options={fOptions}
        series={series}
        type="bar"
        width={width}
        height={height}
      />
    </div>
  );
};

export default BarGraph;
